import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function ProblemSection() {
  return <section className="bg-slate-900 py-24 px-4 text-slate-100 relative overflow-hidden" data-id="element-88">
      {/* Decorative background element */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-slate-700 to-transparent" data-id="element-89"></div>

      <div className="max-w-3xl mx-auto" data-id="element-90">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-91">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-amber-50" data-id="element-92">
            Te han dicho que "es parte de la edad"
          </h2>
          <p className="text-lg text-slate-300 max-w-2xl mx-auto" data-id="element-93">
            Has intentado todo para recuperar tu descanso, pero nada parece
            funcionar a largo plazo.
          </p>
        </motion.div>

        <div className="space-y-6 mb-16" data-id="element-94">
          {['Te han recetado pastillas que te dejan como un zombie al día siguiente.', 'Has probado tés y remedios caseros que no hacen nada.', "Has intentado 'no pensar' pero tu mente sigue corriendo.", 'Te sientes culpable por no tener energía para tu familia.'].map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex items-start gap-4 bg-slate-800/50 p-6 rounded-xl border border-slate-700" data-id="element-95">
              <XCircle className="w-6 h-6 text-red-400 flex-shrink-0 mt-1" data-id="element-96" />
              <p className="text-lg text-slate-200" data-id="element-97">{item}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="bg-amber-900/20 border border-amber-500/30 p-8 rounded-2xl text-center" data-id="element-98">
          <h3 className="text-2xl font-serif text-amber-400 mb-4" data-id="element-99">
            El problema no eres tú
          </h3>
          <p className="text-lg text-slate-200 leading-relaxed" data-id="element-100">
            El problema es que tu cerebro a los 65 años necesita un{' '}
            <span className="font-bold text-amber-200" data-id="element-101">
              "lenguaje" diferente
            </span>{' '}
            para entrar en descanso. Las soluciones químicas fuerzan el apagado,
            pero nunca te dan el sueño reparador que tu cuerpo grita por tener.
          </p>
        </motion.div>
      </div>
    </section>;
}